<template>
  <div class="wrapper">
    <!-- 头部标题 -->
    <page-head title="事件统计" :showBack="false"></page-head>
    <div class="content">
      <!-- <Tabs>
        <TabPane label="事件办理"> -->
          <iframe
            class="iframebox"
            :style="{height:height+'px'}"
            :src="'https://py.shequyun.cn/decision/view/report?viewlet=/jczl/pyeventCount.cpt&communityId='+communityId"
            frameborder="0"
            scrolling="no"
          ></iframe>
        <!-- </TabPane>
      </Tabs> -->
    </div>



  </div>
</template>

<script>
  import pageHead from '../../../components/head';
  export default {
    name: 'eventStatistics',
    components: {
      pageHead,
    },
    data () {
      return {
        communityId:this.$store.state.streetorcommunityid,
        head:'',
        height:'',
      }
    },
    mounted () {
      this.height= document.body.clientHeight-60 - 90-40-30;
      var head = location.origin
      if (head.indexOf('localhost') > -1) this.head = 'http://yanfa.shequyun.cn'
      else this.head = head
    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ivu-tabs-nav .ivu-tabs-tab:hover{
    color:#ff7b44;
  }
  .wrapper{
    min-height: 100%;
    padding-bottom: 30px
  }
  .content{
    margin: 0 20px;
  }
  .iframebox{
    width: 100%;
    background: #fff;
  }
</style>
